export default __webpack_public_path__ + "assets/b5c928bb50f7eb1144a2d783fc3bd498.png";